/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo, useState } from 'react';
import { TabPanel, Tabs } from '@paypalcorp/pp-react';
import styles from './CustomizePageTabSection.module.less';
import { trackTabClick } from '../../../lib/fpti';
import CustomizeSection from '../CustomizePageSection';

interface TabContent {
  [key: string]: any[];
}

interface Tab {
  id: string;
  panelId: string;
  label: string;
}

interface ECMContentItem {
  key: string;
  title: string;
  content: any[];
}

interface CustomizePageTabSectionProps {
  ecmContent: { content: ECMContentItem[] };
}

export const CustomizePageTabSection: React.FC<CustomizePageTabSectionProps> = ({ ecmContent }) => {
  const { content } = ecmContent;
  const [selectedTabIdx, setSelectedTabIdx] = useState(0);

  const { tabList, tabContent } = useMemo(() => {
    const tabList: Tab[] = [];
    const tabContent: TabContent = {};
    content.forEach((tab, idx) => {
      const { key, title, content } = tab;
      tabContent[`${key}_${idx}`] = content;
      tabList.push({
        id: `${key}_${idx}`,
        panelId: `${key}_${idx}`,
        label: title
      });
    });

    return { tabList, tabContent };
  }, [content]);

  return (
    <>
      {tabList.length > 0 && (
        <Tabs
          name="fastlaneUpgradeTabs"
          selectedTabIdx={selectedTabIdx}
          tabs={tabList}
          onClick={(_, idx: number = 0) => {
            trackTabClick(`${tabList[idx].label} tab`);
            setSelectedTabIdx(idx);
          }}
          className={styles.tabs}
        >
          {tabList.map((tab) => (
            <TabPanel
              id={tab.panelId}
              tabId={tab.panelId}
              key={tab.panelId}
              className={styles.tabpanel}
            >
              {tabContent[tab.id].map((item, index) => (
                <React.Fragment key={index}>
                  <CustomizeSection contentIndex={index + 1} ecmContent={item} key={item.id} />
                </React.Fragment>
              ))}
            </TabPanel>
          ))}
        </Tabs>
      )}
    </>
  );
};
